'use client';

import { useEffect } from 'react';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center">
      <div className="text-center">
        <h2 className="text-2xl font-bold text-[#F5F5F0] mb-4">發生錯誤</h2>
        <p className="text-[#888888] mb-6">{error.message}</p>
        <button
          onClick={() => reset()}
          className="px-6 py-3 bg-[#D4AF37] text-[#0A0A0A] rounded-lg font-medium hover:bg-[#D4AF37]/90 transition-colors"
        >
          重試
        </button>
      </div>
    </div>
  );
}
